import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import LeadsDropdown from '../../../../../components/Shared/WebFormLeadsDrodown/index.tsx';
import useInterveneSx from '../../../hooks/useInterveneSx';
import useLeadOverview from '../../../hooks/useLeadOverview';
import {
  getConversationDisplayName,
  getConversationPhone,
} from '../../../utils/conversationIdentity';
import { radiusPx } from '../../../styles/layoutCommon.js';

function OverviewRow({ label, value, styles }) {
  if (value === null || value === undefined || value === '') return null;
  return (
    <Box>
      <Typography sx={styles.overviewLabel}>{label}</Typography>
      <Typography sx={styles.overviewValue}>{value}</Typography>
    </Box>
  );
}

export default function OverviewTab({
  activeUser,
  isDrawerOpen,
  onLeadSelect,
  organisationId,
}) {
  const styles = useInterveneSx().contextDrawer;
  const phone = getConversationPhone(activeUser);
  const displayName = getConversationDisplayName(activeUser, 'User');

  const {
    leadCounts,
    leadDetails,
    userDetailByNumber,
    leadCampaign,
    campaignId,
    leadFormId,
    isLoading,
  } = useLeadOverview({ phone, isDrawerOpen });

  if (!phone) {
    return (
      <Typography variant="body2" color="text.secondary">
        Select a conversation to view lead overview.
      </Typography>
    );
  }

  return (
    <Box>
      <Box sx={styles.overviewCard}>
        <Typography sx={styles.overviewCardTitle}>Customer</Typography>
        <Typography sx={styles.overviewValue}>{displayName}</Typography>
        <Typography sx={styles.overviewLabel}>{phone}</Typography>
      </Box>

      <Box sx={styles.overviewCard}>
        <Typography sx={styles.overviewCardTitle}>Lead</Typography>
        <OverviewRow label="Lead ID" value={leadDetails?.id || leadDetails?.lead_id} styles={styles} />
        <OverviewRow
          label="Campaign"
          value={leadCampaign?.campaign?.name}
          styles={styles}
        />
        <OverviewRow
          label="Form"
          value={leadCampaign?.webForm?.leads_form_name}
          styles={styles}
        />
        <OverviewRow
          label="RG"
          value={userDetailByNumber?.rg_name || leadDetails?.rg_name}
          styles={styles}
        />
        <OverviewRow
          label="Next Action"
          value={leadDetails?.next_action_date}
          styles={styles}
        />

        <Box sx={{ mt: 1.5 }}>
          <LeadsDropdown
            value={leadDetails}
            onChange={(e) => onLeadSelect?.(e)}
            campaignId={campaignId}
            leadFormId={leadFormId}
            phoneNumber={phone}
            label="Select Lead"
            multiSelect={false}
          />
        </Box>

        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
          <Button
            size="small"
            variant="outlined"
            onClick={() => window.open('/r/records/v1', '_blank')}
            sx={{ borderRadius: radiusPx.md }}
          >
            View Full Lead
          </Button>
        </Box>
      </Box>

      <Box sx={styles.overviewCard}>
        <Typography sx={styles.overviewCardTitle}>Stats</Typography>
        {isLoading ? (
          <Typography variant="body2" color="text.secondary">
            Loading…
          </Typography>
        ) : (
          <Box sx={styles.overviewGrid}>
            <OverviewRow label="Total" value={leadCounts?.total_leads ?? 0} styles={styles} />
            <OverviewRow label="Recent (24h)" value={leadCounts?.last_24h_leads ?? 0} styles={styles} />
            <OverviewRow label="Closed" value={leadCounts?.closed_leads ?? 0} styles={styles} />
            <OverviewRow label="Open" value={leadCounts?.open_leads ?? 0} styles={styles} />
          </Box>
        )}
      </Box>
    </Box>
  );
}
